export const uploadContentFormats = '.png, .jpg, .jpeg, .mp4, .mov, .wmv, .avi, .flv, .mkv';
export const uploadIconFormats = '.png, .svg, .jpg, .jpeg';
export const uploadImageFormats = '.png, .jpg, .jpeg';
export const defaultBackground = 'https://res.cloudinary.com/dsypundib/image/upload/v1664563894/static%20images/default-bg_bm4hjs.png';
export const Cloudinary_PRESET = 'l1inehit';
export const Cloudinary_NAME = 'dsypundib';
